export default __webpack_public_path__ + "static/media/Marissa 9781408333914.91e357de.jpg";